import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import RemoveFeeScheduleForm from './form'

const RemoveFeeScheduleDialog = React.forwardRef(function RemoveFeeScheduleDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (client, feeSchedule) => setDialogState({ open: true, processing: false, client, feeSchedule })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Remove Fee Schedule'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<RemoveFeeScheduleForm client={dialogState.client} feeSchedule={dialogState.feeSchedule} onComplete={close} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

RemoveFeeScheduleDialog.propTypes = {
}

export default RemoveFeeScheduleDialog
